/**
 * Personalization Analytics — GA4 dataLayer + gtag events for the ?product= funnel.
 *
 * Events:
 *   personalized_landing        — landing page with ?product= loaded
 *   personalized_cta_click      — CTA clicked on personalized landing page
 *   personalized_collection     — collection page with ?product= loaded
 *   personalized_product_click  — featured product card clicked on collection
 *
 * Fires via both dataLayer (for GTM) and gtag() (for Shopify Google channel).
 */
(function () {
  'use strict';

  if (typeof NDPersonalization === 'undefined') return;

  var handle = NDPersonalization.getProductHandle(window.location.pathname);
  if (!handle) return;

  window.dataLayer = window.dataLayer || [];

  /**
   * Dual-fire: pushes to dataLayer (GTM) and calls gtag() (Shopify Google channel).
   */
  function ndTrack(eventName, eventParams, useBeacon) {
    window.dataLayer.push(Object.assign({ event: eventName }, eventParams));
    if (typeof gtag === 'function') {
      if (useBeacon && navigator.sendBeacon) {
        gtag('event', eventName, Object.assign({ transport_type: 'beacon' }, eventParams));
      } else {
        gtag('event', eventName, eventParams);
      }
    }
  }

  const isCollectionPage = /^\/collections\//.test(window.location.pathname);
  const hasUrlParam = !!new URLSearchParams(window.location.search).get('product');

  // Event: personalized_landing (non-collection pages with ?product= in URL)
  if (!isCollectionPage && hasUrlParam) {
    ndTrack('personalized_landing', {
      personalized_product: handle,
      page_referrer: document.referrer
    });

    // Meta custom audience for retargeting
    try {
      if (typeof fbq === 'function') {
        fbq('trackCustom', 'PersonalizedLanding', { product: handle });
      }
    } catch (e) { /* Ad-blocker proxy objects can throw after typeof check passes */ }
  }

  // Event: personalized_collection (collection pages with ?product= in URL only)
  if (isCollectionPage && hasUrlParam) {
    const collectionHandle = window.location.pathname.replace(/^\/collections\//, '').split(/[/?#]/)[0];
    ndTrack('personalized_collection', {
      personalized_product: handle,
      collection_handle: decodeURIComponent(collectionHandle)
    });
  }

  // Event: personalized_cta_click (CTA buttons on personalized landing pages)
  if (!isCollectionPage) {
    document.addEventListener('click', function (e) {
      const cta = e.target.closest('.nd-cta-pill, .nd-cta-soft, .vv-cta');
      if (!cta) return;
      // Check for data attribute set by nd-cta-passthrough.js (works for both collection and product mode)
      if (!cta.hasAttribute('data-nd-personalized-product')) return;

      const href = cta.getAttribute('href') || '';
      const ctaMode = cta.getAttribute('data-nd-cta-mode') || 'collection';
      const section = cta.closest('[id^="shopify-section-"]');
      const sectionId = section ? section.id.replace('shopify-section-', '') : 'unknown';

      ndTrack('personalized_cta_click', {
        personalized_product: handle,
        cta_url: href,
        cta_mode: ctaMode,
        cta_section: sectionId
      }, true);
    });
  }

  // Event: personalized_product_click (featured product card on collection)
  if (isCollectionPage) {
    document.addEventListener('click', function (e) {
      const card = e.target.closest('li.grid__item[data-featured="true"]');
      if (!card) return;

      const productLink = card.querySelector('a[href]');
      const productUrl = productLink ? productLink.getAttribute('href') : '';

      ndTrack('personalized_product_click', {
        personalized_product: handle,
        product_url: productUrl
      }, true);
    });
  }
})();
